// 当前患者列表总数
export const count = state => state.count;
export const visitCount = state => state.visitCount;
// 选中状态患者数量
export const selectCount = state => state.selectList.length;
// 当前tab
export const currentTabIndex = state => state.currentTabIndex;

// 选中患者id列表
export const selectIdList = (state) => {
  const arr = [];
  state.selectList.forEach((sl) => {
    arr.push(sl.patientId);
  });
  return arr;
};
